import React, { Component } from 'react';
import { connect }          from 'react-redux';
import { addPopup,
         removePopup }      from '../../redux/actions';

//popup types
import * as popups from '../../constants/popup-types';

//popup components
import BasicPopup     from '../../components/popups/basic';
import FavoritesPopup from '../../components/popups/custom/favoritesPopup/favoritesPopup.js';
import CarAlbumPopup  from 'components/popups/custom/carAlbumPopup/carAlbumPopup';
import ValidationPopup  from 'components/popups/custom/validationCodePopup/validationPopup';
import AdvertPopup    from '../../components/popups/custom/resultAdvertPopup/resultAdvertPopup';
import TestForm       from  '../../components/popups/custom/testFormPopup/testForm';

import './index.css';

class Popups extends Component {

    constructor(props) {
        super(props);
        this.state = {}
        this.handleCloseClick = this.handleCloseClick.bind(this);
    }

    handleCloseClick = () => {
        this.props.removePopup();
    }

    render() {

        let currentPopup  = this.props.popupsArray[this.props.popupsArray.length-1];
        let popupToRender = null;

        //handling of specific popup types component and click handlers
        switch(currentPopup.type) {

            case(popups.GENERAL_MESSAGE):
                popupToRender = <BasicPopup popup_id = { currentPopup.popup_id }
                                            text = { currentPopup.text }
                                            handleClose = { this.handleCloseClick }
                                            backdropClick = { this.handleCloseClick } />
                                            break;
            case (popups.FAVORITES):
                popupToRender = <FavoritesPopup text = {currentPopup.text}
                                                popup_id = {currentPopup.popup_id}
                                                handleClose = { this.handleCloseClick }
                                                backdropClick = { this.handleCloseClick }
                                                history={this.props.history}/>
                break;

            case (popups.CAR_ALBUM):
                popupToRender = <CarAlbumPopup  text = {currentPopup.text}
                                                popup_id = {currentPopup.popup_id}
                                                handleClose = { this.handleCloseClick }
                                                backdropClick = { this.handleCloseClick } />
                break;
            case (popups.VALIDATION_CODE):
                popupToRender = <ValidationPopup
                                                 onClose = { this.handleCloseClick }
                                                 backdropClick = { this.handleCloseClick }
                                                 onStepUp ={currentPopup.stepUp}
                                                 email={currentPopup.email}/>
                break;
            // case (popups.ADVERT):
            //     popupToRender = <AdvertPopup   onClose = { this.handleCloseClick }
            //                                    backdropClick = { this.handleCloseClick }
            //                                    handleClose = { this.handleCloseClick }/>
            //     break;
            case (popups.TEST_FORM):
                popupToRender = <TestForm onClose={this.handleCloseClick}
                                          backdropClick={this.handleCloseClick}
                                          handleClose={this.handleCloseClick}
                                          image={currentPopup.image}/>
                break;
            default:
                popupToRender = <BasicPopup text = { 'Unknown popup type: ' + currentPopup.type}
                                            handleClose = { this.handleCloseClick } />
        }

        return (
            <div className = "popup">
                { popupToRender }
            </div>
        )
    }
}

//connect to Redux store
const mapStateToProps = store => {
    return {
        popupsArray: store.state.popupsArray
    }
}
const mapDispatchToProps = dispatch => {
    return {
        addPopup: (payload) => dispatch(addPopup(payload)),
        removePopup: () => dispatch(removePopup()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Popups);